import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(( theme ) => ({
  root: {
    "& .visibilityContainer, & .dragHandleContainer": {
      backgroundColor: theme.props.backgroundSecondary
    }
  },
  altBackground: {
    "& .visibilityContainer, & .dragHandleContainer": {
      backgroundColor: theme.props.background
    }
  },
  overflows: {
    "& .display-overflow": {
      borderRightStyle: "dashed !important",
      borderRightWidth: "1px !important",
      borderRightColor: `${ theme.props.border } !important`,
      "& .bordered": {
        borderRightWidth: "0 !important"
      }
    },
    "& .display-overflow-right": {
      borderLeftStyle: "dashed !important",
      borderLeftWidth: "1px !important",
      borderLeftColor: `${ theme.props.border } !important`,
    },
    "& .descriptionRow": {
      maxWidth: ({ containerWidth }) => containerWidth - CELL_WIDTHS.DRAG_HANDLE,// - CELL_WIDTHS.VISIBILITY - 1,
      minWidth: ({ containerWidth }) => containerWidth - CELL_WIDTHS.DRAG_HANDLE,//- CELL_WIDTHS.VISIBILITY - 1,
    },
    "& .descriptionFiller": {
      width: "100%",
    },
  },
}));

export default useStyle;